import { Record } from "immutable";

const SurveyAttrRecord = Record({
  id: null,
  order: "",
  // 追加
  attrName: "",
  // 関連
  attrItems: []
});

class SurveyAttr extends SurveyAttrRecord {}

export default SurveyAttr;



// WEBPACK FOOTER //
// ./src/models/SurveyAttr.js